import { render, staticRenderFns } from "./AuctionFilters.vue?vue&type=template&id=23c5c0a7&scoped=true"
import script from "./AuctionFilters.vue?vue&type=script&lang=js"
export * from "./AuctionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c5c0a7",
  null
  
)

export default component.exports